import { Accordion, Center, createStyles, Flex, Loader } from "@mantine/core";
import { useParams } from "react-router-dom";
import { Breadcrumb, IPropsBreadcrumb } from "../../../../components";
import PageNotFound from "../../../PageNotFound";
import AccordionHistory from "./AccordionHistory";
import { useMyPlansById } from "../../../../hooks/useMyPlans";
import ConfigProvider from "./ConfigProvider";
import { useTranslation } from "react-i18next";
import InfosDashboard from "./InfosDashboard";
import FirstConfig from "./FirstConfig";
import AccordionConfig from "./AccordionConfig";
import AccordionDanger from "./AccordionDanger";

const ConfigurationProduct = () => {
  const { slug } = useParams();
  const id = slug?.split("id=")[1];
  const { t } = useTranslation();

  const { data, isLoading, isError, isFetched, isRefetching, isFetching } =
    useMyPlansById({
      id: id,
    });

  const isModifyConfig =
    (!!data?.is_accepted_term && !!data?.accepted_term_date) ||
    data?.has_pending_scheduled_actions;

  const breacrumbs: IPropsBreadcrumb[] = [
    {
      title: t(
        "meu_portfolio.minhas_compras.configuracao_do_serviço.breadcrumb.title_first"
      ),
      href: "/meu-portfolio/minhas-compras",
    },
    {
      title: t(
        "meu_portfolio.minhas_compras.configuracao_do_serviço.breadcrumb.title_second"
      ),
      href: "",
    },
  ];

  if ((isError && isFetched && !data) || !id) return <PageNotFound />;

  return (
    <>
      <Center bg="other.3">
        <Flex
          direction="column"
          w="100%"
          maw={1680}
          mx={{ base: 24, 768: 60 }}
          mb={100}
          gap={"16px"}
        >
          <Breadcrumb navlinks={breacrumbs} />
          {isLoading ? null : !!data ? <InfosDashboard product={data} /> : null}
        </Flex>
      </Center>

      <Center mt={-100} pb={{ base: 24, 768: 60 }}>
        <Flex
          mt={48}
          direction="column"
          w="100%"
          maw={1800}
          px={{ base: 24, 768: 60 }}
          sx={{ filter: " drop-shadow(0px 25px 35px rgba(0, 0, 0, 0.03))" }}
        >
          <Flex
            justify="space-between"
            align="center"
            bg="basic.0"
            p={{ base: "16px", 991: "32px" }}
            wrap={{ base: "wrap" }}
            sx={{ borderRadius: "12px" }}
            w="100%"
          >
            {isLoading ? (
              <Center h="200px" w="100%">
                <Loader />
              </Center>
            ) : !!data ? (
              <>
                <ConfigProvider product={data} isRefetching={isRefetching}>
                  {isModifyConfig ? (
                    <Accordion w={"100%"} defaultValue={["Config"]} multiple>
                      <AccordionConfig />
                      <AccordionDanger />
                      <AccordionHistory product={data} />
                    </Accordion>
                  ) : (
                    <FirstConfig name={data.product.title} />
                  )}
                </ConfigProvider>
              </>
            ) : (
              t(
                "meu_portfolio.minhas_compras.configuracao_do_serviço.id_not_found"
              )
            )}
          </Flex>
        </Flex>
      </Center>
    </>
  );
};

export default ConfigurationProduct;
